import { browser } from '$app/environment';
import { localStorageSupported } from '$lib/helper/browser';

export enum AppLocale {
	fr = 'fr',
	en = 'en'
	//	es = 'es',
	//	de = 'de'
}

export const getLocaleFlag = (locale: AppLocale) => {
	switch (locale) {
		case AppLocale.fr:
			return '🇫🇷';
		case AppLocale.en:
			return '🇬🇧';
		//		case AppLocale.es:
		//			return '🇪🇸';
		//		case AppLocale.de:
		//			return '🇩🇪';
		default:
			console.warn(`Unknown locale flag: ${locale}`);
			return locale;
	}
};

// Return the detected locale from the browser and user preferences
export function detectLocale(): AppLocale {
	const defaultLocale = AppLocale.fr; // Fallback locale
	const supportedLocales = Object.values(AppLocale);

	let navigatorComputedLocale = null;
	if (browser && localStorageSupported()) {
		navigatorComputedLocale = localStorage.getItem('locale') || navigator.language;
	}

	// Get the preferred language from the browser
	// Choose local storage value first, otherwise use navigator language, otherwise use defaultLocale
	const browserLocale = navigatorComputedLocale || defaultLocale;

	// Extract the language from the browser locale (Example: 'fr-FR' => 'fr')
	const browserLanguage = browserLocale.split('-')[0];

	// Simple mapping from language to full locale
	const localeMapping: { [key: string]: AppLocale } = {
		fr: AppLocale.fr,
		//		es: AppLocale.es,
		//		de: AppLocale.de,
		en: AppLocale.en
	};

	// Get the full locale from mapping or use browserLocale if it's already in supportedLocales
	const detectedLocale: AppLocale =
		localeMapping[browserLocale] || localeMapping[browserLanguage] || browserLocale;

	// Check if the detected locale is supported, otherwise fallback to defaultLocale
	return supportedLocales.includes(detectedLocale) ? detectedLocale : defaultLocale;
}
